import { useEffect, useState } from 'react';
import '../../assets/stylesheets/Content/content_slider.scss'

export default function ContentSlider({sliderList, section}) {

    const [intervalId, setIntervalId] = useState(null)
    const [currentIndex, setCurrentIndex] = useState(0);
    const ANIMATION_TIME = 500;
    const slider_time_limit = 3000;

    const navigationOnClick = (s_direction) => {
        const slider_frame = document.getElementById(`${section}_window_slider`);
        const slides = slider_frame.getElementsByClassName('slider_wrapper');
        const navigations = document.getElementById(`${section}_slider_navigation_wrapper`).getElementsByClassName('slider_navigation');
    
        // Removing the 'slider_active' class from all slides and navigations
        for (let slide of slides) {
            slide.style.transition = 'opacity 1s ease-in-out'; // Apply transition to all slides
            slide.style.opacity = '0'; // Set opacity of all slides to 0
            slide.classList.remove('slider_active');
        }

        let index = -1;
        // Find the index of the currently active slide
        for (let i = 0; i < navigations.length; i++) {
            if (navigations[i].classList.contains('slider_active')) {
                index = i;
                break;
            }
        }
    
        if (index === -1) {
            console.error('No active slide found.');
            return;
        }

        setCurrentIndex(index);

        if((index === 0 && s_direction === 'left')|| (index === slides.length - 1 && s_direction === 'right')){
            return;
        } 

        clearInterval(intervalId)

        for (let navigation of navigations) {
            navigation.classList.remove('slider_active');
        }
       
        if (s_direction === 'left') {
            index = (index - 1 + slides.length) % slides.length;
        } else if (s_direction === 'right') {
            index = (index + 1) % slides.length;
        }
        // Set the opacity of the selected slide to 1 and add 'slider_active' class to its navigation
        slides[index].style.opacity = '1';
        slides[index].classList.add('slider_active');
        navigations[index].classList.add('slider_active');

        const intervalID= setInterval(_slider, slider_time_limit + ANIMATION_TIME);
        setIntervalId(intervalID)
    };
    
    const navigationOnButtonClick = (idx) => {
        clearInterval(intervalId); // Clear the interval
        const index = parseInt(idx); // Parse the index as an integer
        setCurrentIndex(index);
        const slider_frame = document.getElementById(`${section}_window_slider`);
        const slides = slider_frame.getElementsByClassName('slider_wrapper');
        const navigations = document.getElementById(`${section}_slider_navigation_wrapper`).getElementsByClassName('slider_navigation');
    
        // Removing the 'slider_active' class from all slides and navigations
        for (let slide of slides) {
            slide.style.transition = 'opacity 1s ease-in-out'; // Apply opacity transition to all slides
            slide.style.opacity = '0'; // Set opacity of all slides to 0
            slide.classList.remove('slider_active');
        }

        for (let navigation of navigations) {
            navigation.classList.remove('slider_active');
        }
        
        slides[index].style.opacity = '1';
        slides[index].classList.add('slider_active');
        navigations[index].classList.add('slider_active');

        const intervalID = setInterval(_slider, slider_time_limit + ANIMATION_TIME);
        setIntervalId(intervalID)

    }

    useEffect(()=>{
        const _slider = () => {
            const windowSlider = document.getElementById(`${section}_window_slider`);
            const slides = windowSlider ? windowSlider.getElementsByClassName('slider_wrapper') : [];
            const navigationWrapper = document.getElementById(`${section}_slider_navigation_wrapper`);
            const navigations = navigationWrapper ? navigationWrapper.getElementsByClassName('slider_navigation') : [];

            if (!windowSlider || !navigationWrapper) {
                // console.error('Slider elements not found.');
                return;
            }

            let currentSlide = windowSlider.querySelector('.slider_wrapper.slider_active');
            if (!currentSlide) {
                currentSlide = slides[0]; // Set the first slide as active if none are marked as active
                currentSlide.style.opacity = '1'; // Ensure the first slide is visible initially
                currentSlide.classList.add('slider_active');
                navigations[0].classList.add('slider_active');
            }
            // Set interval to call _slider periodically
            for (let slide of slides) {
                slide.style.opacity = '0';
                slide.classList.remove('slider_active');
            }
            currentSlide.style.opacity = '1'; 
            currentSlide.classList.add('slider_active');
        }
        _slider();
    },[])

    const _slider = () => {
        const windowSlider = document.getElementById(`${section}_window_slider`);
        const slides = windowSlider ? windowSlider.getElementsByClassName('slider_wrapper') : [];
        const navigationWrapper = document.getElementById(`${section}_slider_navigation_wrapper`);
        const navigations = navigationWrapper ? navigationWrapper.getElementsByClassName('slider_navigation') : [];

        if (!windowSlider || !navigationWrapper) {
            // console.error('Slider elements not found.');
            return;
        }

        for (let slide of slides) {
            slide.style.transition = 'opacity 0.5s ease-in-out';
            slide.style.opacity = '0';
        }

        let currentSlide = windowSlider.querySelector('.slider_wrapper.slider_active');
        if (!currentSlide) {
            currentSlide = slides[0]; // Set the first slide as active if none are marked as active
            currentSlide.style.opacity = '1'; // Ensure the first slide is visible initially
            currentSlide.classList.add('slider_active');
            navigations[0].classList.add('slider_active');
        }

        const nextIndex = (Array.from(slides).indexOf(currentSlide) + 1) % slides.length;
        const nextSlide = slides[nextIndex];
        setCurrentIndex(nextIndex);
        currentSlide.style.opacity = '0';
        nextSlide.style.opacity = '1';

        for (let slide of slides) {
            slide.classList.remove('slider_active');
        }

        currentSlide.classList.remove('slider_active');
        nextSlide.classList.add('slider_active');

        for (let navigation of navigations) {
            navigation.classList.remove('slider_active');
        }
        navigations[nextIndex].classList.add('slider_active');

    };

    useEffect(() => {
        setTimeout(() => {
            const intervalID = setInterval(_slider, slider_time_limit + ANIMATION_TIME);
            setIntervalId(intervalID)
            return () => clearInterval(intervalId); // Cleanup function to clear interval
        }, 100);
    }, []);
    

    return (
        <>
        <div className={`slider_main_wrapper ${section}`}>
            <div id={`${section}_window_slider`} className={`slider_main_container window_slider ${section}`}>
                {
                sliderList.map((slider, index) => {
                    return (
                    <div key={`slider_${index}`}  id={`${section}_slider_wrapper`} className='slider_wrapper'>
                        <div className='slider_container slider_detail'>
                            {slider}
                        </div>
                    </div>
                    )
                })
                }
            </div>
            {<div className={`slider_nav_responsive_container ${section}`}>
                <div className='slider_nav_responsive_left' onClick={()=>{
                    if(currentIndex===0)
                        return;
                    navigationOnClick('left')
                }}
                ><span className={`path1 ${currentIndex === 0  ? 'inactive' : ''}`}></span><span className={`path2 ${currentIndex === 0  ? 'inactive' : ''}`}></span></div>
                <div className='slider_nav_responsive_right' onClick={()=>{
                    if(currentIndex=== sliderList.length -1)
                        return 
                    navigationOnClick('right')
                }}
                ><span className={`path1 ${currentIndex === sliderList.length -1 ? 'inactive' : ''}`}></span><span className={`path2 ${currentIndex === sliderList.length -1  ? 'inactive' : ''}`}></span></div>
            </div>}
        </div>
        <div id={`${section}_slider_navigation_wrapper`} className={`slider_navigation_wrapper ${section}`} >
            <div className={`slider_nav left ${section} ${currentIndex === 0  ? 'inactive' : ''}`} onClick={()=>{
                if(currentIndex===0)
                    return;
                navigationOnClick('left')
            }}></div>
        {
            sliderList.map((slider,index) => {
            return (
                <div key={`${index}`} id={`${section}_slider_navigation`} onClick={()=>{navigationOnButtonClick(index)}} className={`slider_navigation ${section}`}>
                </div>
            )
            })
        }
            <div className={`slider_nav right ${section} ${currentIndex === sliderList.length -1  ? 'inactive' : ''}`} onClick={()=>{
                if(currentIndex=== sliderList.length -1)
                    return 
                navigationOnClick('right')
            }}></div>
        </div>
        </>
    )
}


